import type { AdministratorSettingsPayload } from '../shared/types';

export function createConfirmation(
	shouldSend: boolean,
	channels: Array<'email' | 'sms'>,
	status: AdministratorSettingsPayload | null,
): string {
	if (!shouldSend) return 'Draft intake created.';
	if (
		status?.deliveryMode === 'provider' &&
		status.settings.outbound_delivery_enabled &&
		channels.length === 1 &&
		channels[0] === 'email'
	) {
		return 'Intake created. Your email invitation is being sent.';
	}
	return 'Intake created and invitation queued.';
}

export function friendlyCreateError(error: unknown): string {
	if (error instanceof TypeError) {
		return 'Connection lost. Refresh the page, sign in again if prompted, and check Active intakes before trying again.';
	}
	return error instanceof Error ? error.message : 'Unable to create intake';
}
